import React, { Component } from "react";
import { message, Typography } from "antd";
import {
  ButtonItem,
  InputNumberItem,
  SelectInsumosItem,
} from "../../../../Components/Items";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";

const { Text } = Typography;

//Renglones editables del check "Editar insumos" de Refacturar Venta. Mismo armado que
//EditarRemisionVenta; la lista vive en ModalRefacturarVenta, que es quien la manda al backend.
class TablaInsumosRefactura extends Component {
  state = {
    insumoSelectKey: 0,
    nuevoInsumoId: null,
    nuevoInsumoSeleccionado: null,
    nuevoCantidad: 1,
    nuevoPrecio: 0,
  };

  actualizarLinea(index, campo, valor) {
    const insumos = [...this.props.insumos];
    insumos[index] = { ...insumos[index], [campo]: valor };
    this.props.onChange(insumos);
  }

  quitarLinea(index) {
    const insumos = [...this.props.insumos];
    insumos.splice(index, 1);
    this.props.onChange(insumos);
  }

  agregarLinea() {
    if (!this.state.nuevoInsumoId || !this.state.nuevoCantidad) {
      message.warning("Selecciona el insumo y la cantidad a agregar.");
      return;
    }
    const insumo = this.state.nuevoInsumoSeleccionado;
    this.props.onChange([
      ...this.props.insumos,
      {
        insumoId: this.state.nuevoInsumoId,
        proyectoId: this.props.proyectoId,
        cantidad: this.state.nuevoCantidad,
        precioUnitario: this.state.nuevoPrecio || 0,
        descuento: 0,
        descuentoCantidad: 0,
        entregado: 0,
        clave: insumo?.clave,
        descripcion: insumo?.descripcion,
      },
    ]);
    this.setState({
      nuevoInsumoId: null,
      nuevoInsumoSeleccionado: null,
      nuevoCantidad: 1,
      nuevoPrecio: 0,
      insumoSelectKey: this.state.insumoSelectKey + 1,
    });
  }

  //Lo mismo que valida el backend, para avisar antes de previsualizar
  notaRenglon(valueInsumo) {
    if (valueInsumo.hospedaje) return "Estancia de hotel: no se puede cambiar su cantidad.";
    if (valueInsumo.conLotes) return "Tiene lotes o marbetes: no se puede bajar su cantidad.";
    if (valueInsumo.costeado) return "Servicio ya costeado: no se puede bajar su cantidad.";
    return null;
  }

  render() {
    const { insumos, moneda } = this.props;
    //Los precios se capturan en la moneda de la factura
    const etiquetaPrecio = moneda && moneda !== "MXN" ? `Precio unitario (${moneda})` : "Precio unitario";

    return (
      <>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 5 }}>
          <div style={{ flex: 2 }}><Text type="secondary">Insumo</Text></div>
          <div style={{ flex: 1 }}><Text type="secondary">Cantidad</Text></div>
          <div style={{ flex: 1 }}><Text type="secondary">{etiquetaPrecio}</Text></div>
          <div style={{ flex: 1 }}><Text type="secondary">Descuento %</Text></div>
          <div style={{ width: 32 }} />
        </div>

        {insumos.map((valueInsumo, index) => {
          const nota = this.notaRenglon(valueInsumo);
          return (
            <div
              key={valueInsumo._id || `nuevo-${index}`}
              style={{ marginBottom: 10, borderBottom: "1px solid #eee", paddingBottom: 10 }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ flex: 2 }}>
                  <Text strong>
                    {valueInsumo.clave ? valueInsumo.clave + " - " : ""}
                    {valueInsumo.descripcion}
                  </Text>
                  {!valueInsumo._id ? (
                    <div>
                      <Text type="success" style={{ fontSize: 12 }}>Nuevo: quedará por entregar</Text>
                    </div>
                  ) : null}
                  {valueInsumo.entregado > 0 ? (
                    <div>
                      <Text type="secondary" style={{ fontSize: 12 }}>Ya entregado: {valueInsumo.entregado}</Text>
                    </div>
                  ) : null}
                  {nota ? (
                    <div>
                      <Text type="warning" style={{ fontSize: 12 }}>{nota}</Text>
                    </div>
                  ) : null}
                </div>
                <div style={{ flex: 1 }}>
                  <InputNumberItem
                    min={0}
                    value={valueInsumo.cantidad}
                    placeholder="Cantidad"
                    disabled={!!valueInsumo.hospedaje}
                    onChange={(v) => this.actualizarLinea(index, "cantidad", v)}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <InputNumberItem min={0} value={valueInsumo.precioUnitario} placeholder="Precio unitario" dinero onChange={(v) => this.actualizarLinea(index, "precioUnitario", v)} />
                </div>
                <div style={{ flex: 1 }}>
                  <InputNumberItem min={0} max={100} value={valueInsumo.descuento} placeholder="Descuento %" onChange={(v) => this.actualizarLinea(index, "descuento", v)} />
                </div>
                <ButtonItem rojoB lessTime icon={<DeleteOutlined />} onClick={() => this.quitarLinea(index)} />
              </div>
            </div>
          );
        })}

        <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 15 }}>
          <div style={{ flex: 2 }}>
            <SelectInsumosItem
              key={this.state.insumoSelectKey}
              empresaId={this.props.empresaId}
              headersToken={this.props.headersToken}
              tiposInsumos="venta"
              width="100%"
              placeholder="Agregar insumo..."
              onChange={(value, insumo) => this.setState({ nuevoInsumoId: value, nuevoInsumoSeleccionado: insumo })}
            />
          </div>
          <div style={{ flex: 1 }}>
            <InputNumberItem min={0} value={this.state.nuevoCantidad} placeholder="Cantidad" onChange={(v) => this.setState({ nuevoCantidad: v })} />
          </div>
          <div style={{ flex: 1 }}>
            <InputNumberItem min={0} value={this.state.nuevoPrecio} placeholder={etiquetaPrecio} dinero onChange={(v) => this.setState({ nuevoPrecio: v })} />
          </div>
          <ButtonItem type="primary" lessTime icon={<PlusOutlined />} onClick={this.agregarLinea.bind(this)}>
            Agregar
          </ButtonItem>
        </div>
      </>
    );
  }
}

export default TablaInsumosRefactura;
